<template>
  <div id="app" :class="browser.name">
    <component :is="layout"/>
  </div>
</template>

<script>
const { detect } = require('detect-browser');
const browser = detect();
import FrontLayout from "@/components/FrontLayout";
import AuthLayout from "@/components/AuthLayout";
import LoggedInLayout from "@/components/LoggedInLayout";
import UuidRandom from "uuid-random";
import _ from "lodash";

export default {
  name: "App",
  components: {
    "front-layout": FrontLayout,
    "auth-layout": AuthLayout,
    "logged-in-layout": LoggedInLayout
  },
  data() {
    return {
      browser
    }
  },
  computed: {
    layout() {
      return this.$store.getters.layout;
    }
  },
  mounted() {
    if (document.getElementById('onload_preview')) {
      document.getElementById('onload_preview').remove();
    }
  },
  created() {
    this.setUpUuid();
    this.$auth.ready(function () {
      if (this.$auth.check()) {
        const user = this.$auth.user();
        console.log('user is ', user)
        this.$store.dispatch("setUser", user || {});
      } else {
        console.log('user not connected')
        this.$store.dispatch("setUser", {});
      }
    })
  },
  methods: {
    setUpUuid() {
      console.log({uuid: this.$store.getters.uuid})
      if (!this.$store.getters.uuid) {
        this.$store.commit('uuid', UuidRandom());
      }
    }
  }
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "colors";
$material-icons-font-path: "~material-icons/iconfont/";
$material-icons-css-prefix: "mdi" !default;
@import "~material-icons/iconfont/material-icons.scss";
@import "~material-icons/css/material-icons.scss";
@import "helpers";

// Set your colors
//$primary: #1C7C9C
$primary-invert: findColorInvert($primary);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);

.has-text-action {
  color: $action;
}
.has-text-secondary {
  color: $secondary;
}

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "twitter": (
    $twitter,
    $twitter-invert
  )
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
@import "~bulma-utilities/sass/bulma-utilities";

.has-margin-auto {
  margin: auto;
}

.mw-70px {
  min-width: 70px;
}
.mw-110px {
  min-width: 110px;
}

.v-cal {
  padding: 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.live-edit input {
  border: 0 none;
  box-shadow: none !important;
}
.card-header-title .live-edit input {
  font-weight: 700;
  font-size: 14px;
}
h1,
h2,
h3 {
  font-family: "Montserrat";
  font-weight: 300;
  &.title {
    font-weight: 300;
  }
  &.bold {
    font-weight: 700;
  }
}

.mdi-16px {
  font-size: 16px !important;
}
.mdi-18px {
  font-size: 18px !important;
}
.mdi-20px {
  font-size: 20px !important;
}
.mdi-36px {
  font-size: 36px !important;
}
.mdi-48px {
  font-size: 48px !important;
}

.has-text-primary-light {
  color: $primaryLight !important;
}
.has-flex-grow-1 {
  flex-grow: 1;
}
.has-flex-wrap {
  flex-wrap: wrap;
}
.vcenter,
.has-aligned-center {
  align-items: center;
}
.has-aligned-top {
  align-items: flex-start !important;
}
.has-justified-center {
  justify-content: center;
}
.has-justified-start {
  justify-content: start;
}

.spacer.is-1 {
  height: 1rem;
}

.has-sb {
  justify-content: space-between;
}

.spacer {
  display: block;
  margin: 0;
  padding: 0;
  height: 0;
  background: none;
  border: none;
}

hr.separator {
  height: 1px;
  clear: both;
  width: 100%;
  margin: 0px auto 10px;
}
.on-separator {
  background-color: #fff;
  padding: 0px 10px;
  position: relative;
  display: block;
  width: 70px;
  margin: -24px auto 20px;
}
hr.separator:not(.idx-0) {
  margin-top: 40px;
}

.has-text-underline {
  text-decoration: underline;
}

.modal {
  z-index: 100;
}
.columns.is-vcentered {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.mt12 {
  margin-top: 12px;
}
.mt20 {
  margin-top: 20px;
}

.mb12 {
  margin-bottom: 12px;
}
.mb20 {
  margin-bottom: 20px;
}

body .modal-content,
body .modal-card {
  width: 100%;
}

.has-light-background,
.hero.is-success {
  background: #f2f6fa;
}

.hero.is-primary div.card-footer-item {
  color: inherit;
}

.mb0 {
  margin-bottom: 0 !important;
}

.ptb0,
.pbt0 {
  padding-top: 0;
  padding-bottom: 0;
}

.faded {
  opacity: 0.3;
}

.faded:hover {
  opacity: 1;
}

.is-wide {
  flex-grow: 1;
}

.text-align-right {
  text-align: right;
}

.has-loader.is-loading {
  color: transparent !important;
  pointer-events: none;
  position: relative;
  opacity: 0.5;
}
.has-loader.is-loading:after {
  -webkit-animation: spinAround 500ms infinite linear;
  animation: spinAround 500ms infinite linear;
  border: 2px solid #dbdbdb;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  height: 1em;
  position: relative;
  width: 1em;
  position: absolute;
  left: calc(50% - (1em / 2));
  top: calc(50% - (1em / 2));
  position: absolute !important;
}
.is-primary.is-outlined.is-loading:hover:after,
.is-primary .has-loader.is-loading:after {
  border: 2px solid #fff;
  border-color: transparent transparent #fff #fff !important
}
.has-loader.is-primary.is-outlined.is-loading:after {
  border-color: transparent transparent #FF5B62 #FF5B62 !important;
}
.is-smoothly-animated {
  transition: all 0.3s ease;
}

.mdi-16px {
  font-size: 16px !important;
}
.mdi-18px {
  font-size: 18px !important;
}
.mdi-20px {
  font-size: 20px !important;
}
.mdi-24px {
  font-size: 24px !important;
}

.mdi-spin,
.fa-spin {
  -webkit-animation: fa-spin 2s infinite linear;
  animation: fa-spin 2s infinite linear;
}

.mdi-eye:before {
  content: "\E417";
}



@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

.is-small-dropdown .dropdown-menu {
  min-width: 4rem;
  text-align: center;
  a.dropdown-item,
  .has-link a {
    padding-right: 1rem;
  }
}

.card-header {
  .button {
    height: 56px;
  }
}

html {
  scroll-behavior: smooth;
}

body {
  .dg-btn--ok {
    color: $primary;
  }
  .dg-btn--ok {
    border-color: $primary;
  }
  .dg-btn--cancel {
    background-color: $primary;
  }

  .dg-btn-loader .dg-circle {
    background-color: $primary;
  }
}

.is-middle {
  vertical-align: middle;
}
.is-disabled {
  opacity: 0.7;
  cursor: not-allowed;
  /*pointer-events: none;*/
}

.has-shadow {
  box-shadow: 0px 2px 14px #DEDEDE;
}

.is-flex-column {
  display: flex;
  flex-direction: column;
}

.mdi {
  font-size: inherit;
}

i[class*="flag"] {
  width: 24px;
  height: 24px;
  background-size: cover !important;
  display: inline-block;
  vertical-align: middle;
  margin: 0 5px 0 0;
  &.is-small {
    width: 16px;
    height: 16px;
  }
}

.dropdown-menu {
  z-index: 50;
}

.mt--5px {
  margin-top: -5px;
}
.pt0 {
  padding-top: 0 !important;
}

span.icon + span {
  padding-left: 6px;
}

section.hero h1.title {
  font-size: 2rem !important;
  font-weight: 300 !important;
}

/*@media screen and (min-width: 769px) {*/
body .hero.is-medium .hero-body {
  padding-top: 2rem;
}
.mdi-arrow-up:before {
  content: "\E5D8";
}
.mdi-arrow-down:before {
  content: "\E5DB";
}
.table-mobile-sort {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  margin-top: 0.25rem;
}
/*}*/
@media screen and (max-width: 768px) {
  html {
    font-size: 14px;
  }
  body .b-table .table.has-mobile-cards tr:not(:last-child) {
    margin-bottom: 0rem;
  }
  body .b-table .table.has-mobile-cards tr {
    padding: 0.5rem;
    td:last-child {
      border-bottom: 0 none !important
    }
  }
  body .b-table .table.has-mobile-cards tr.detail {
    margin-top: 0;
  }
}

@media screen and (max-width: 425px) {
  .brand .brand-subtitle {
    font-size: 0.8rem !important;
  }
  .modal-content {
    margin: 0 0.2em !important;
    max-width: 100% !important;
    width: 100% !important;
    overflow: visible;
    .container {
      margin-top: 0 !important;
      max-width: 100% !important;
      width: 100% !important;
    }
  }
}

@media screen and (max-width: 320px) {
  body {
    .brand .brand-icon {
      width: 36px;
      height: 39px;
    }
    .brand .brand-icon img {
      max-width: 38px;
      max-height: 38px;
    }
    .navbar-burger {
      height: 55px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue